import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const FeatureSearchSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default FeatureSearchSVG;
